var _rect, _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFollowUpMailIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3.40741,
    fill: "#E2E2F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9498 4.7998C18.1924 4.7998 19.1998 5.80717 19.1998 7.0498V12.2313C18.9234 12.003 18.6218 11.8042 18.2998 11.6395V8.3647L12.228 11.9377C12.1106 12.0067 11.9698 12.0183 11.8446 11.9722L11.7716 11.9377L5.6998 8.3665V14.2498C5.6998 14.9954 6.30422 15.5998 7.0498 15.5998H11.12C11.1066 15.748 11.0998 15.8982 11.0998 16.0498C11.0998 16.2015 11.1066 16.3516 11.12 16.4998H7.0498C5.80717 16.4998 4.7998 15.4924 4.7998 14.2498V7.0498C4.7998 5.80717 5.80717 4.7998 7.0498 4.7998H16.9498ZM16.9498 5.6998H7.0498C6.30422 5.6998 5.6998 6.30422 5.6998 7.0498V7.3216L11.9998 11.0277L18.2998 7.3207V7.0498C18.2998 6.30422 17.6954 5.6998 16.9498 5.6998Z",
    fill: "#3C3ADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 16.05C20.1 18.2868 18.2868 20.1 16.05 20.1C13.8132 20.1 12 18.2868 12 16.05C12 13.8132 13.8132 12 16.05 12C18.2868 12 20.1 13.8132 20.1 16.05ZM16.05 13.8C15.8015 13.8 15.6 14.0015 15.6 14.25V16.05C15.6 16.2985 15.8015 16.5 16.05 16.5H17.4C17.6485 16.5 17.85 16.2985 17.85 16.05C17.85 15.8015 17.6485 15.6 17.4 15.6H16.5V14.25C16.5 14.0015 16.2985 13.8 16.05 13.8Z",
    fill: "#3C3ADA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFollowUpMailIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FollowUpMailIcon.e4db8918.svg";
export { ForwardRef as ReactComponent };